module.exports = __webpack_public_path__ + "static/media/Loding.dc6bcf17.gif";